var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComingsoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 15,
    viewBox: "0 0 74 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.5,
    r: 7,
    fill: "#E93416"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 7.5,
    r: 7,
    fill: "#FE7200"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 7.5,
    r: 7,
    fill: "#008E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComingsoon);
export default __webpack_public_path__ + "static/media/icon_comingsoon.9546e1408cfb5b60355e5891285cb676.svg";
export { ForwardRef as ReactComponent };